import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-slate-50 border-t border-slate-200 pt-20 pb-10" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-49">
          {/* Brand */}
          <div className="col-span-1 lg:col-span-1" data-id="element-50">
            <Link to="/" className="text-2xl font-bold tracking-tight text-blue-900 mb-6 block" data-id="element-51">
              AMO<span className="text-blue-600" data-id="element-52">WTS</span>
            </Link>
            <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-53">
              Providing safe, reliable, and compassionate door-to-door
              wheelchair transportation in Charlotte and surrounding areas.
            </p>
            <div className="flex space-x-4" data-id="element-54">
              {[Facebook, Twitter, Instagram].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all" data-id="element-55">
                  <Icon className="w-5 h-5" data-id="element-56" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-57">
            <h4 className="font-bold text-slate-900 mb-6" data-id="element-58">Quick Links</h4>
            <ul className="space-y-4" data-id="element-59">
              {[{
              name: 'Home',
              href: '/'
            }, {
              name: 'Wheelchair Transport',
              href: '/wheelchair-transport'
            }, {
              name: 'Services',
              href: '/services'
            }, {
              name: 'Service Area',
              href: '/service-area'
            }, {
              name: 'About Us',
              href: '/about'
            }, {
              name: 'Contact',
              href: '/contact'
            }].map(link => <li key={link.name} data-id="element-60">
                  <Link to={link.href} className="text-slate-600 hover:text-blue-600 flex items-center group" data-id="element-61">
                    <ArrowRight className="w-4 h-4 mr-2 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-62" />
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-63">
            <h4 className="font-bold text-slate-900 mb-6" data-id="element-64">Our Services</h4>
            <ul className="space-y-4" data-id="element-65">
              {['Medical Appointments', 'Dialysis Treatment', 'Physical Therapy', 'Social Outings', 'Shopping Trips'].map(service => <li key={service} data-id="element-66">
                  <a href="#" className="text-slate-600 hover:text-blue-600" data-id="element-67">
                    {service}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-68">
            <h4 className="font-bold text-slate-900 mb-6" data-id="element-69">Contact Us</h4>
            <ul className="space-y-4" data-id="element-70">
              <li className="flex items-start" data-id="element-71">
                <MapPin className="w-5 h-5 text-blue-600 mr-3 mt-1" data-id="element-72" />
                <span className="text-slate-600" data-id="element-73">
                  Charlotte, North Carolina & Surrounding Areas
                </span>
              </li>
              <li className="flex items-center" data-id="element-74">
                <Phone className="w-5 h-5 text-blue-600 mr-3" data-id="element-75" />
                <a href="tel:7040000000" className="text-slate-600 hover:text-blue-600" data-id="element-76">
                  (704) AMO-RIDE
                </a>
              </li>
              <li className="flex items-center" data-id="element-77">
                <Mail className="w-5 h-5 text-blue-600 mr-3" data-id="element-78" />
                <a href="mailto:info@amowts.com" className="text-slate-600 hover:text-blue-600" data-id="element-79">
                  info@amowts.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-80">
          <p className="text-slate-500 text-sm" data-id="element-81">
            © {new Date().getFullYear()} AMO Wheelchair Transportation
            Services. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-slate-500" data-id="element-82">
            <a href="#" className="hover:text-blue-600" data-id="element-83">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-blue-600" data-id="element-84">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}